<script>

import router from "@/router.js";
import { mapState } from "vuex";
import IconStatus from "@/components/dashboard/helpers/IconStatus.vue";

export default {
  name: 'QuestionStatus',
  components: {
    IconStatus,
  },
  props:{
    resp:{
      type: Object,
      required: true,
    },
    dialog_comment:{
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data(){
    return {
      need_change_status: false,
      comment_form: undefined,
      persistent_dialog: true,
      try_status: undefined,
    }
  },
  computed:{
    ...mapState({
      is_ies: state => state.is_ies,
      editable: state => state.ies_year_data.register_referance.status.can_ies_change,
      all_status: state => state.all_status,
    }),
    reviewer_status(){
      return this.all_status.filter(x=>
        (x.name == 'validated' || x.name == 'need_changes')
        && x.id !== this.resp.status.id
      )
    },
    need_qualified(){
      return !this.resp.status.send_admin && !this.is_ies
    },
  },    
  methods:{
    open_dialog_comment(open_comment=true){
      this.$emit('update:dialog_comment', open_comment)
      if (this.is_ies){
        if (this.persistent_dialog && !open_comment){ 
          //console.log("el caso especial de cierre")
          this.$emit('dialog_update')
        }
      }
      else if (!open_comment && this.try_status){
        this.try_status = undefined
      }
      if (!open_comment)
        this.persistent_dialog = true
    },
    indirect_close_dialog(){
      if (!this.persistent_dialog) this.open_dialog_comment(false)
    },
    save_comment(){
      //console.log(this.$refs.comment.validate())
      if (this.$refs.comment.validate()){
        var snack_text = "Se ha guardado tu nota"
        var author = this.is_ies ? 'ies' : 'revisor' 
        this.$store
          .dispatch('UPDATE_NOTE', {
              data: {
                text:this.resp.last_note,
                author: author
              },
              answer_id:this.resp.id,
              snack_text: snack_text
            })
          .then((data) => {
            if (this.need_change_status){
              if (this.try_status)
                this.change_answer()
              this.need_change_status = false
            }
            this.$emit('update:dialog_comment', false)
          })
          .catch(error =>
            console.log(error)
          );
        }
    },
    change_answer(status){
      let new_status_id = status 
        ? status.id 
        : this.try_status 
          ? this.try_status.id
          : null
      this.$store
        .dispatch('UPDATE_ANSWER', { 
          data: {
            status_register: new_status_id
          }, 
          error: !new_status_id,
          answer_id: this.resp.id,
          snack_text: "Se ha guardado el nuevo status"
        })
        .then((data) => {
          this.try_status = undefined
          //console.log(data)
        })
        .catch(error =>{
          console.log(error)
        });
    },
    changeStatus(new_status){
      let st_name = new_status.name
      if (st_name == 'need_changes'){
        this.need_change_status = true
        this.try_status = new_status
        this.open_dialog_comment()
      }
      else if (st_name == 'validated')
        this.change_answer(new_status)
    }
  },
}
</script>

<template>
  <div class="float-left ml-3">
    <v-col  align="center" class="px-1">
      <IconStatus :status="resp.status" :inactived="need_qualified"/>
    </v-col>
    <v-col align="center" v-if="!is_ies">
      <v-menu>
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn 
                color="accent"
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
                :icon="!need_qualified"
                :small="need_qualified"
                :fab="need_qualified"
              >
                <v-icon dark>edit</v-icon>
              </v-btn>
            </template>
            <span>
              {{ need_qualified ? "Calificar" : "Cambiar calificación" }}
            </span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item v-if="true">
            <span class="grey--text">
              ¿Qué validación tendrá la respuesta?
            </span>
          </v-list-item>
          <v-list-item
            v-for="(st, index) in reviewer_status"
            :key="index"
            @click="changeStatus(st)"
          >
            <v-list-item-icon>
              <v-icon v-text="st.icon" :color="st.color"></v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ st.description }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>        
      
    </v-col>
    <v-divider></v-divider>
    <v-col class="px-1">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            icon color="blue-grey lighten-2"
            v-on="on"
            @click="open_dialog_comment(), persistent_dialog=false"
          >
            <v-icon>{{resp.last_note ? 'comment' : 'add_comment'}}</v-icon>
          </v-btn>
        </template>
        <span>{{resp.last_note ? 'Editar' : 'Agregar'}} nota</span>
      </v-tooltip>
    </v-col>

    <v-dialog
      v-model="dialog_comment"
      max-width="450"
      :persistent="persistent_dialog"
      @click:outside="indirect_close_dialog()"
    >
      <!--@click:outside="indirect_close_dialog()"-->
      <v-card>
        <v-form 
          lazy-validation
          ref="comment"
          v-model="comment_form"
        >
          <v-card-title class="headline no-wrap text-center">
            <span v-if="is_ies">
              Escribe las referencias necesarias para que el revisor compruebe tu respuesta
            </span>
            <span v-else>
              Escribe una nota para la IES
            </span>
          </v-card-title>
          <v-card-text>
            <p>{{resp.pregunta.indicaciones}}</p>
            <v-textarea
              label="Escribe aquí las referencias o una nota"
              v-model="resp.last_note"
              hint="Intenta escribir con claridad"
              :rules="[v => !!v || 'Requiere que escribas algo']"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="open_dialog_comment(false)"
            >
              Cerrar
            </v-btn>            
            <v-btn
              color="primary"
              @click="save_comment()"
              :disabled="!comment_form"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>

.bottom-el{
  vertical-align: bottom;
}
</style>